module.exports = __webpack_public_path__ + "static/media/Highland Ave San Carlos, CA6.a6c8ca8c.jpg";